














import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxIconChip } from '@/axiom';

@Component({
    components: {
    },
})
export default class IconChip extends Vue {
    @Prop({ required: true }) public entityChipData: any;
    private previousIsResponsive: boolean = false;

    public get contextCode(): string {
        return this.entityChipData?.contextCode;
    }

    public get entityName(): string {
        return this.entityChipData?.entityName;
    }

    public get entityCode(): string {
        return `#${this.entityChipData?.entityCode}`;
    }

    public get entityIconColor(): string {
        return this.entityChipData?.iconColor;
    }

    public get entityIconFontColor(): string {
        return this.entityChipData?.iconFontColor;
    }

    public get isResponsive():boolean {
        return this.entityChipData && this.entityChipData.isResponsive? true : false
    }

    public updated() {
        if(this.isResponsive !== this.previousIsResponsive){
            AxIconChip.destroy(this.$refs.chip as HTMLElement);
            AxIconChip.init((this.$refs.chip as HTMLElement), this.isResponsive);
            this.previousIsResponsive = this.isResponsive;
        }
    }

    public mounted() {
        AxIconChip.init((this.$refs.chip as HTMLElement), this.isResponsive);
        this.previousIsResponsive = this.isResponsive;
    }
}
